import React, { PropsWithChildren, useState } from "react";
import { clsx } from "clsx";
import { BiSearchAlt } from "react-icons/bi";
import { GiHamburgerMenu } from "react-icons/gi";
import { RxCross1 } from "react-icons/rx";
import { Link } from "gatsby";
import Drawer from "./Drawer";
import Search from "./Search";

interface IHeaderProps extends PropsWithChildren {}

export default function Header(props: IHeaderProps) {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [isSearchOpen, setIsSearchOpen] = useState(false);

  const onDrawerClick = () => {
    setIsDrawerOpen(!isDrawerOpen);
    setIsSearchOpen(false);
  };

  const onSearchClick = () => {
    setIsSearchOpen(!isSearchOpen);
    setIsDrawerOpen(false);
  };

  return (
    <div
      className={clsx(
        "sticky",
        "top-0",
        {
          "h-screen": isDrawerOpen,
        },
        "w-full",
        "z-[1]",
      )}
    >
      <header
        className={clsx(
          "bg-primary",
          "flex",
          "items-center",
          "justify-center",
          "px-4",
          "py-3",
          "text-primary-content",
          "w-full",
        )}
      >
        <label className={clsx("swap", "swap-rotate")}>
          <input
            type="checkbox"
            onChange={onDrawerClick}
            checked={isDrawerOpen}
          />
          <GiHamburgerMenu className={clsx("swap-off")} size={20} />
          <RxCross1 className={clsx("swap-on")} size={20} />
        </label>
        <div className={clsx("flex-1", "text-center")}>
          <Link
            className="btn btn-ghost btn-sm font-icon normal-case text-2xl"
            to="/"
          >
            ウィーンペディア
          </Link>
        </div>
      </header>
      <div
        className={clsx(
          "bg-pink",
          "flex",
          "items-center",
          "justify-center",
          "px-3",
          "py-2",
          "w-full",
        )}
      >
        <p className={clsx("font-bold", "text-xs")}>
          ［重要］本帰国に伴い、すべての更新・運営を2025年5月30日をもって終了します。
        </p>
      </div>

      <div
        className={clsx(
          "sticky",
          "duration-500",
          "h-full",
          {
            "opacity-0": !isDrawerOpen,
            "opacity-100": isDrawerOpen,
          },
          "overflow-scroll",
          "top-12",
          "transition-opacity",
          "w-full",
        )}
      >
        <Drawer isDrawerOpen={isDrawerOpen} />
      </div>
    </div>
  );
}
